import {AxiosClientFactory} from "../../common/helpers/AxiosClientFactory";
import {CommandResult} from "../../common/helpers/CommandResult";

export const deleteMarketingList = (id: number): Promise<CommandResult> => {
    return AxiosClientFactory
        .getInstance()
        .delete(`/api/marketingLists/${id}`)
        .then((result) => new CommandResult(result));
};